(function () {
  const el = document.querySelector('[data-fc-hotelkey]');
  if (!el) return;

  let target = 0;
  let current = 0;
  let lastScrollY = 0;
  let idlePhase = 0;
  let scrollTimeout = null;

  // Anchor to header bottom (header.height - 36) — matches manus line 95
  function syncTop() {
    const header = document.querySelector('.fc-header') || document.querySelector('header');
    if (!header) return;
    const h = header.getBoundingClientRect().height;
    el.style.top = (h - 36) + 'px';
  }
  syncTop();
  window.addEventListener('resize', syncTop);
  // Re-measure when header height changes (e.g. flash sale dismissed)
  const headerEl = document.querySelector('.fc-header');
  if (headerEl && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(syncTop).observe(headerEl);
  }

  // Smooth spring animation loop — 60fps via rAF, lerp factor 0.08 (matches manus line 48)
  function spring() {
    const diff = target - current;
    current += diff * 0.08;
    el.style.transform = 'rotate(' + current + 'deg)';
    requestAnimationFrame(spring);
  }
  requestAnimationFrame(spring);

  // Scroll handler: swing in direction of scroll, clamp to ±18°, reset 150ms after idle
  window.addEventListener('scroll', function () {
    const y = window.scrollY;
    const delta = y - lastScrollY;
    lastScrollY = y;
    target = Math.max(-18, Math.min(18, delta * 0.6));
    if (scrollTimeout) clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () { target = 0; }, 150);
  }, { passive: true });

  // Idle sway: sin wave ±4° when not actively scrolling (manus lines 80-85)
  setInterval(function () {
    idlePhase += 0.04;
    if (Math.abs(target) < 2) {
      target = Math.sin(idlePhase) * 4;
    }
  }, 16);
})();
